// ─────────────────────────────────────────────
//  ConditionChip — compact room-condition tag (Phase 5.2).
//  Pure/presentational: renders one condition (icon + label + truncated note)
//  in the taxonomy tints from domain/conditions. Display-only on the dense
//  board card — never a tap target (posting/clearing happens in My Room /
//  the ConditionPicker modal). Rectangular tag, NOT a pill, so it can't be
//  confused with the canonical StatusPill (C-002).
// ─────────────────────────────────────────────
import React from "react";
import { getConditionMeta } from "../domain/conditions";
import tokens from "../theme/tokens";

const { font, radius } = tokens;

export default function ConditionChip({ kind, note = "", compact = false }) {
  if (!kind) return null;
  const meta = getConditionMeta(kind);
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        maxWidth: "100%",
        background: meta.bg,
        border: `1px solid ${meta.border}`,
        color: meta.text,
        borderRadius: radius.sm,
        padding: "2px 8px",
        fontSize: font.size.label,
        fontWeight: font.weight.bold,
        lineHeight: 1.2,
      }}
      title={note ? `${meta.label} — ${note}` : meta.label}
    >
      <span aria-hidden="true">{meta.icon}</span>
      <span>{meta.label}</span>
      {!compact && note && (
        <span
          style={{
            fontWeight: 400,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: 140,
          }}
        >
          · {note}
        </span>
      )}
    </span>
  );
}
